import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import * as aserver from '../../APIClient';
import Badge from '@material-ui/core/Badge';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, 
  },
  
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
  },
}));

// eslint-disable-next-line 
class Messages extends Component {  constructor(props) {
    super(props);
    this.state = {
        coachId: localStorage.getItem('Id'),
        messages:[],
        };  
  }

  getMessages=async()=>{
    let getMessages = await aserver.get(`api/v3/coaches/${this.state.coachId}/messages?all=true`);
    this.massageData(getMessages.data)
  }

  massageData =(data)=>{
    for(let record of data){
      aserver.convertUTCToLocal(record, 'updatedAt');
    }
    this.setState({
      messages: data
    })
  }


  markMessagesAsRead=async()=>{
    if (localStorage.getItem("impersonator")!=='true')
      await aserver.get(`api/v3/coaches/${this.state.coachId}/ackedLatestMessages`)
  }

  componentDidMount(){
    this.getMessages()
    this.markMessagesAsRead()
  }

  render() {
    const classes = this.props.classes;

    return (
      <>
      <div className={classes.root}>
          <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Container maxWidth="lg" className={classes.container}>
                  <Grid item xs={12} md={12} lg={12}>
                      {this.state.messages.map((info, i)=>{
                          return (
                            <Paper key={i}>
                                <Badge color="secondary" invisible={!info.newMessage} badgeContent="new"></Badge>
                                <div className='messageHead'>
                                    <h2>{info.subject}</h2>
                                    <h2>{info.updatedAt}</h2>
                                </div>
                                <p style={{textAlign:"left", padding:"0 17% 1% 17%"}} dangerouslySetInnerHTML={{__html: info.body}}></p>
                            </Paper>
                          )
                      })}
                    
                  </Grid>
              </Container>
          </main>
      </div>
</>
    )
  }
}

// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return (
      <Messages classes={classes} />
  )
};
 
